import { useNavigate } from 'react-router-dom';
import { CloseSvg } from 'utils/svgs';
import MappingTable from './MappingTable';
import styles from './index.module.scss';

const EmployeeMappingComponent = () => {
	const navigate = useNavigate();
	return (
		<div className={styles['time-logs']}>
			<div className={styles['time-logs__header']}>
				<div className={styles['time-logs__header__title']}>
					Assign Supervisor
				</div>
				<div
					className={styles['time-logs__header__actions']}
					onClick={() => {
						navigate('/monthly-summary');
					}}
				>
					<CloseSvg />
				</div>
			</div>
			<div className={styles['time-logs__table']}>
				<MappingTable />
			</div>
		</div>
	);
};

export default EmployeeMappingComponent;
